import { getSynapseTheme, setSynapseTheme } from '@/core/SynapsePreferences';

import { ThemeName } from './types';

const key = 'waldur/theme/name';

const isThemeName = (value: string | null): value is ThemeName =>
  value === 'light' || value === 'dark';

export const getLocalTheme = (): ThemeName | undefined => {
  const value = localStorage.getItem(key);
  return isThemeName(value) ? value : undefined;
};

export const getTheme = (): ThemeName | undefined =>
  getSynapseTheme() || getLocalTheme();

export const setTheme = (value: ThemeName) => {
  localStorage.setItem(key, value);
};

export const setSharedTheme = (value: ThemeName) => {
  setTheme(value);
  setSynapseTheme(value);
};

export const migrateThemePreference = () => {
  if (getSynapseTheme()) {
    return;
  }

  const localTheme = getLocalTheme();

  if (localTheme) {
    setSynapseTheme(localTheme);
  }
};
